module.exports = __webpack_public_path__ + "static/charles-30523d5cce5945e799afb29caf10578f.jpg";